var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page-section"},[_c('div',{staticClass:"container"},[_c('ErrorCatcher',{ref:"errorCatcher"})],1),_vm._v(" "),_c('div',{staticClass:"page-section-container container",class:_vm.innerClass},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }